import { isBrowser } from "@/utils/is.browser";
import { getEnv, getPublicEnv } from "@tucan/utils";

export function getGraphQLUrl(
  options: { path?: string; websocket?: boolean } = {},
): string {
  const url = new URL(
    String(getEnv("ENDPOINT") || getPublicEnv("ENDPOINT")),
    isBrowser() ? window.location.href : "http://localhost",
  );

  const base = url.pathname === "/" ? "" : url.pathname;

  if (options.path) {
    url.pathname = `${base}${options.path}`;
  } else {
    url.pathname = `${base}/graphql`;
  }

  if (options.websocket) {
    url.protocol = url.protocol.replace("http", "ws");
  }

  return url.toString();
}
